import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

export class Button extends Component { // This should be used as base button class
    static propTypes = {
        action: PropTypes.func.isRequired,
        params: PropTypes.any,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        inputAttrs: PropTypes.object
    }

    static defaultProps = {
        params: null,
        className: "button-doc-sm",
        disabled: false,
        inputAttrs: null
    }

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        this.props.action(this.props.params);
    }

    render() {
        return <button onClick={this.onClick} disabled={this.props.disabled} className={this.props.className}>{this.props.children}</button>
    }
}

export class ActionLink extends Component {
    static propTypes = {
        action: PropTypes.func,
        to: PropTypes.string,
        params: PropTypes.any,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        inputAttrs: PropTypes.object
    }

    static defaultProps = {
        params: null,
        to: null,
        className: "",
        disabled: false,
        inputAttrs: null
    }

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        if (this.props.action) {
            this.props.action(this.props.params);
        }
    }

    render() {
        if (this.props.to) {
            return <Link to={this.props.to} className={'action-btn ' + this.props.className} onClick={this.onClick} disabled={this.props.disabled}>
                {this.props.children}
            </Link>
        } else {
            return <div className={'action-btn ' + this.className} onClick={this.onClick} disabled={this.props.disabled}>
                <FormattedMessage id='General_CoreFunctionality_UIText_general.delete' />
            </div>
        }
    }
}

export const BulkActivateButton = ({ action, disabled = false }) =>
    <button onClick={action} disabled={disabled}
            className="button-doc-sm"><FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.activate" /></button>;

export const BulkPauseButton = ({ action, disabled = false }) =>
    <button onClick={action} disabled={disabled}
            className="button-doc-sm"><FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.pause" /></button>;

export const BulkDownloadButton = ({ action, disabled = false }) =>
    <button onClick={action} disabled={disabled}
            className="button-doc-sm"><FormattedMessage id="UserAudit_Download_UIText_modalActions.download" /></button>;

export const BulkDeleteButton = ({ action, disabled = false }) =>
    <button onClick={action} disabled={disabled}
            className="button-doc-sm"><FormattedMessage id="General_CoreFunctionality_UIText_general.delete" /></button>;

export const CreateNewAlert = ({ action }) =>
    <span>
        <span className="separator" />
        <button onClick={action} className="button-doc-sm create-new-alert__btn">
            <FormattedMessage id="Alerts_Manage_UIText_createAlert" />
        </button>
    </span>;

export const PauseButton = ({ action, item }) =>
    <a className={"action-btn " + (item.busy ? "disabled" : "")} onClick={action}>{item.active ?
        <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.pause" /> :
        <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.resume" />}
    </a>;

export const BulkPreviewButton = ({ action, disabled = false }) =>
    <button onClick={action} disabled={disabled}
            className="button-doc-sm"><FormattedMessage id="Entities_Review_UIText_reviewCompanies.preview" /></button>;

export const CreateNewCategory = ({ action }) =>
    <span>
        <span className="separator" />
        <button onClick={action} className="button-doc-sm create-new-alert__btn">
            <FormattedMessage id="Alerts_Manage_UIText_createCategory" />
        </button>
    </span>;

export const DeleteButton = ({ action, disabled = false }) =>
    <button onClick={action} disabled={disabled}
            className="button-doc-sm"><FormattedMessage id="General_CoreFunctionality_UIText_general.delete" /></button>;



// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/Buttons.jsx